export default class AuthZeroOrganizationViewModel {
    constructor(data){
        this.id = data.id;
        this.name = data.name;
        this.logoUrl = data.logoUrl;
    }
}